import axios from 'axios';
import { useQuery } from 'react-query';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

interface SetActivityMetrics {
  totalLearnerCount: number | null;
  lastStudiedAt: string | null;
  mostRecentlyActiveCourse: {
    id: string;
    name: string;
  } | null;
}

const getSetActivityMetrics = async (setId: string): Promise<SetActivityMetrics> => {
  const endpoint = `/api/v3/sets/${setId}?include_activity_metrics=true`;
  const response = await axios.get(endpoint);
  const { totalLearnerCount, lastStudiedAt, mostRecentlyActiveCourse } = normalizeJSONAPIResponse(response.data);
  return { totalLearnerCount, lastStudiedAt, mostRecentlyActiveCourse };
};

export const useGetSetActivityMetrics = (setId: string | null) => {
  return useQuery(['setActivityMetrics', setId], () => getSetActivityMetrics(setId!), {
    enabled: !!setId,
  });
};
